import web3Service from '../../web3-service';
import OM_STAKING_MIGRATE_ABI from '../../../blockchain/abi/OM_STAKING_MIGRATE.json';
import config from '../../../config/env';

class OmStakingMigrationContractService {
  constructor() {
    this._contract = new web3Service.eth.Contract(
      OM_STAKING_MIGRATE_ABI,
      config.REACT_APP_OM_STAKING_MIGRATION_ADDRESS,
    );
  }

  get contract() {
    return this._contract;
  }

  async accounts(address) {
    return this.contract.methods.accounts(address).call();
  }

  async lockStakingPoolV1Rewards(address) {
    const options = { from: address };
    return this.contract.methods.lockStakingPoolV1Rewards().send(options);
  }

  async lockStakingPoolV2Rewards(address) {
    const options = { from: address };
    return this.contract.methods.lockStakingPoolV2Rewards().send(options);
  }

  async migrate(address) {
    const options = { from: address };
    return this.contract.methods.migrate().send(options);
  }
}

export default new OmStakingMigrationContractService();
